import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';

import {Servers} from 'features/server';

const ServersPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <Servers />
        </MainLayout>
    );
};

export default ServersPage;
